// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_UV5","cls2":"FriendlySutdModal-cls2_Pn5 FriendlySutdModal-cls1_UV5"};